"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "zenevredo": {
    "b08cb9e5": [{
      "hkey": "ae7ddd72",
      "slug": "zenevredo",
      "name": "Zenevredo",
      "primary": true,
      "skipSearch": false
    }],
    "balerio": [{
      "hkey": "ae7ddd72",
      "slug": "zenevredo",
      "name": "Zenevredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "190031d6": [{
      "hkey": "ae7ddd72",
      "slug": "zenevredo",
      "name": "Zenevredo",
      "primary": true,
      "skipSearch": false
    }],
    "boccazza": [{
      "hkey": "ae7ddd72",
      "slug": "zenevredo",
      "name": "Zenevredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "70598903": [{
      "hkey": "ae7ddd72",
      "slug": "zenevredo",
      "name": "Zenevredo",
      "primary": true,
      "skipSearch": false
    }],
    "bosco": [{
      "hkey": "ae7ddd72",
      "slug": "zenevredo",
      "name": "Zenevredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7b30a4d9": [{
      "hkey": "5234037f",
      "slug": "casa-nuova",
      "name": "Casa Nuova",
      "primary": true,
      "skipSearch": false
    }],
    "casanova": [{
      "hkey": "5234037f",
      "slug": "casa-nuova",
      "name": "Casa Nuova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "83eccbaf": [{
      "hkey": "df514bcf",
      "slug": "cascina-vecchia",
      "name": "Cascina Vecchia",
      "primary": true,
      "skipSearch": false
    }],
    "cassina-vecchia": [{
      "hkey": "df514bcf",
      "slug": "cascina-vecchia",
      "name": "Cascina Vecchia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a20f4996": [{
      "hkey": "ae7ddd72",
      "slug": "zenevredo",
      "name": "Zenevredo",
      "primary": true,
      "skipSearch": false
    }],
    "furtovalle": [{
      "hkey": "ae7ddd72",
      "slug": "zenevredo",
      "name": "Zenevredo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "63376e9c": [{
      "hkey": "fccf9ad9",
      "slug": "bellaria-poggio-pelato",
      "name": "Bellaria-Poggio Pelato",
      "primary": true,
      "skipSearch": false
    }],
    "poggio-pelato": [{
      "hkey": "fccf9ad9",
      "slug": "bellaria-poggio-pelato",
      "name": "Bellaria-Poggio Pelato",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;